module.exports = __webpack_public_path__ + "static/media/soul-bottom-cloud-right.ea698999.svg";